import React from "react";
import Typography from "@material-ui/core/Typography";

interface Props {
  amount: number;
  simple?: boolean;
}

const AkadFitrah = ({ simple, amount }: Props) => {
  if (simple) {
    return (
      <>
        <Typography variant="h5">NIAT DAN LAFAZ AKAD FITRAH</Typography>
        <Typography variant="body1">
          "Inilah wang bagi menggantikan beras fitrah sebanyak RM {amount} yang
          wajib bagi diriku pada tahun ini kerana Allah Taala."
        </Typography>
      </>
    );
  }

  return (
    <>
      <Typography variant="h5">NIAT DAN LAFAZ AKAD FITRAH</Typography>
      <Typography variant="body1">
        Mereka yang berfitrah hendaklah ia berniat seperti berikut:
      </Typography>
      <Typography variant="h6">1. Lafaz untuk diri sendiri</Typography>
      <Typography variant="body1">
        "Inilah wang bagi menggantikan beras fitrah sebanyak RM {amount} yang
        wajib ke atas diriku pada tahun ini kerana Allah Ta'ala."
      </Typography>
      <Typography variant="h6">
        2. Lafaz untuk diri sendiri dan tanggungan
      </Typography>
      <Typography variant="body1">
        "Inilah wang bagi menggantikan beras fitrah sebanyak RM {amount} yang
        wajib ke atas diriku dan tanggunganku pada tahun ini kerana Allah
        Ta'ala."
      </Typography>
      <Typography variant="h6">3. Lafaz bagi pihak</Typography>
      <Typography variant="body1">
        "Inilah wang bagi menggantikan beras fitrah sebanyak RM {amount} yang
        wajib ke atas pihak yang aku wakili ... pada tahun ini kerana Allah
        Ta'ala."
      </Typography>
    </>
  );
};

export default AkadFitrah;
